import * as React from "react";
import { HeroRive } from "./hero-rive";

export function HeroSection() {
  return (
    <div className="aspect-square w-full max-w-xl">
      <HeroRive className="h-full w-full" scale={1} />
    </div>
  );
}
